import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { uniq } from 'lodash';

import FilterSection from "./filterSection";
import LocationFilter from './LocationFilter';
import JobFilter from './JobFilter';
import './filterPanel.scss';

const MainContainer = styled.div`
  width: 100%;
`;

class FilterList extends Component {
  createSection = () => {
    const { filters, storeData, handleLoadToCoverOffers } = this.props;

    let myActiveManagerSettings = [0, 1]; // MyShift && Paycodes
    let availableActiveManagerSettings = [0, 1];

    myActiveManagerSettings = myActiveManagerSettings.concat(storeData.employeeShiftRequests.map(x => x.managerSettingId))
      .concat(storeData.employeeShiftOffers.map(x => x.managerSettingId))
      .concat(storeData.employeeMyShiftSwapOffers.map(x => x.managerSettingId))
      .concat(storeData.myProposals.map(x => x.managerSettingId))
      .concat(storeData.myOpenShiftRequests.map(x => x.managerSettingId))
      .concat(storeData.myVTORequests.map(x => x.managerSettingId));

    availableActiveManagerSettings = availableActiveManagerSettings.concat(storeData.availableShiftsToCover.map(x => x.managerSettingId))
    .concat(storeData.availableShiftToSwapOffers.filter(x => !x.isSkipValidation).map(x => x.managerSettingId))
    .concat(storeData.availableVTO.map(x => x.managerSettingId));

    let availableOpenShifts = storeData.availableOpenShifts.map(x => x.managerSettingIds);
    for (let os in availableOpenShifts) {
      availableActiveManagerSettings = availableActiveManagerSettings.concat(availableOpenShifts[os]);
    }

    myActiveManagerSettings = uniq(myActiveManagerSettings);
    availableActiveManagerSettings = uniq(availableActiveManagerSettings);

    const sectionsToSkip = ['location', 'job'];
    let sections = [];
    for (let section in filters) {
      if (sectionsToSkip.includes(section)) {
				continue;
			}

      sections.push(
        <FilterSection
          key={JSON.stringify(section)}
          title={section}
          section={section}
          myActiveManagerSettings={myActiveManagerSettings}
          availableActiveManagerSettings={availableActiveManagerSettings}
          handleLoadToCoverOffers={handleLoadToCoverOffers}
        />
      );
    }
    return sections;
  };
  render() {
    let sections = this.createSection();
    return (
    <MainContainer>
      {sections}
      <LocationFilter />
      <JobFilter />
      </MainContainer>
      );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters,
    storeData: state.data
  };
};

export default connect(mapStateToProps)(FilterList);
